import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { type LeaderboardEntry } from '@/common/types/league';
import { StringSmall } from '@/components/Typography/Typography';
import { useAppSelector } from '@/redux/store';

import { useDevDecoration } from '../../PositionItem/decorations/useDevDecoration';
import { PositionItem } from '../../PositionItem/PositionItem';

interface Props {
  array: LeaderboardEntry[];
  nearbyUsers: LeaderboardEntry[] | undefined;
  userPosition: number | undefined;
}

const AllParticipantsList: React.FC<Props> = ({
  array,
  userPosition,
  nearbyUsers,
}) => {
  const myUserId = useAppSelector((state) => state.user.user?.id);
  const devDecorationId = useDevDecoration();
  const { t } = useTranslation();
  const itemUser = array?.find((el) => el.position === userPosition);

  return (
    <div className="flex flex-col gap-1 relative">
      <div className="flex justify-between py-[0.625rem] px-4 rounded-lg bg-white/5">
        <StringSmall className="!text-gray-500/70">
          {t('All time TOP')}
        </StringSmall>
        <StringSmall className="!text-gray-500/70">
          {t('Arena Score')}
        </StringSmall>
      </div>
      <div
        id="league-rank"
        className="w-full flex flex-col gap-1 mb-1 relative"
      >
        {array?.map((props) => {
          console.log(props);

          const isMe = myUserId === props.user_id;

          return (
            <PositionItem
              style={
                isMe
                  ? {
                      top: 'var(--header-height)',
                    }
                  : undefined
              }
              className={cn(isMe && 'sticky bottom-0 z-[4]')}
              isUserPosition={isMe}
              decorationId={
                isMe && devDecorationId ? devDecorationId : props.decorationId
              }
              key={props.user_id}
              rewards={undefined}
              {...props}
            />
          );
        })}
        {!itemUser && nearbyUsers && (
          <>
            <div className="flex items-center justify-center gap-2 h-8">
              {Array.from({ length: 3 }).map(() => (
                <div className="bg-white/20 w-2 h-2 rounded-[50%]"></div>
              ))}
            </div>
            {nearbyUsers.map((props) => {
              const isMe = myUserId === props.user_id;

              return (
                <PositionItem
                  style={
                    isMe
                      ? {
                          top: 'var(--header-height)',
                        }
                      : undefined
                  }
                  className={cn(isMe && 'sticky bottom-0 z-[4]')}
                  isUserPosition={isMe}
                  decorationId={
                    isMe && devDecorationId
                      ? devDecorationId
                      : props.decorationId
                  }
                  key={props.user_id}
                  rewards={undefined}
                  {...props}
                />
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default AllParticipantsList;
